import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import './lib/slick';
//import './lib/lightbox';
import lightbox from 'lightbox2';
//require('imagesloaded');
//var jQueryBridget = require('jquery-bridget');
//var Isotope = require('isotope-layout');
//jQueryBridget( 'isotope', Isotope, $ );
//import circleProgress from 'jquery-circle-progress';
import AOS from 'aos';
//import Swiper from "swiper";
//import SwiperCore, { Navigation, Pagination, Controller, Mousewheel, Thumbs, History, HashNavigation  } from 'swiper/core';
//SwiperCore.use([Navigation, Pagination, Controller, Mousewheel, Thumbs, History, HashNavigation]);
import counterUp from "counterup2";
//require('./lib/jquery.waypoints');

$(document).foundation();


lightbox.option({
    albumLabel: 'Bild %1 von %2',
});

//$('h2').attr('data-aos', 'fade-up'); // you may add more data attributes if required
//$('h3').attr('data-aos', 'fade-up'); // you may add more data attributes if required

AOS.init({
    disable: 'mobile',
    mirror: true
});



$(function() {
    $('a[href*=\\#]:not([href=\\#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            && location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 180//offsets for fixed header
                }, 800);
                return false;
            }
        }
    });
    if($(location.href.split("#")[1])) {
        var target = $('#'+location.href.split("#")[1]);
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - 180 //offset height of header here too.
            }, 800);
            return false;
        }
    }
});

//Menu Icon Switch
$("button.menu-icon").on("click", function () {
    if ($(this).parent().hasClass("open")) {
        $(this).parent().removeClass("open");
    } else {
        $(this).parent().addClass("open");
    }
});


$("button.menu-icon").on("click", function () {
    if ($(document.getElementsByTagName('header')).hasClass("fixed")) {
        $(document.getElementsByTagName('header')).removeClass("fixed");
    } else {
        $(document.getElementsByTagName('header')).addClass("fixed");
    }
});
$("button.menu-icon").on("click", function () {
    if ($(document.getElementsByTagName('body')).hasClass("fixed")) {
        $(document.getElementsByTagName('body')).removeClass("fixed");
    } else {
        $(document.getElementsByTagName('body')).addClass("fixed");
    }
});


var heroslide = $('.heroslide');
if (heroslide.length) {
    $('.heroslide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 2000,
    });
}



//Header Fixed

$(window).scroll(function() {
    var sticky = $('header'),
        scroll = $(window).scrollTop();

    if (scroll >= (window.innerHeight / 2)) {
        sticky.addClass('fixedscroll'); }
    else if(scroll <= 10) {
        sticky.removeClass('fixedscroll');
    }
});

//Header Fixed

$('.checkbox').on('click', function () {
    $('input:not(:checked)').parent('label').removeClass("is-selected");
    $('input:checked').parent('label').addClass("is-selected");
});


//Barkarte
/*
const sections = document.querySelectorAll("section");
const navLi = document.querySelectorAll(".categories ul li");
window.onscroll = () => {
    var current = "";

    sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (pageYOffset >= sectionTop - 180) {
            current = section.getAttribute("id"); }
    });

    navLi.forEach((li) => {
        li.classList.remove("active");
        if (li.classList.contains(current)) {
            li.classList.add("active");
        }
    });
};
*/

//Dark Mode
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    // the following code allows multiple cookie values and splits them apart
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}
function enableDarkMode() {
    $("body").addClass("light");
    $(".darkmode").text("Daymode");
    $("#switch").prop('checked', true);
    setCookie('darkMode', "1", 7);
}
function disableDarkMode() {
    $("body").removeClass("light");
    $(".darkmode").text("Nightmode");
    $("#switch").prop('checked', false);
    setCookie('darkMode', "0", 7);
}
$("#switch, .darkmode").on("click", function () {
    if ($("body").hasClass("light")) {
        disableDarkMode();
    } else {
        enableDarkMode();
    }
});
document.addEventListener("DOMContentLoaded", function () {
    var darkMode = getCookie('darkMode');
    if (darkMode == "1") {
        // use darkmode
        enableDarkMode();
    } else {
        // no darkmode
        disableDarkMode();
    }
});
//Dark Mode
